{
  "familyId": "TAA-WOORD-IDIOOM",
  "questions": [
    {
      "id": "TAA-WOORD-IDIOOM-001",
      "familyId": "TAA-WOORD-IDIOOM",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "woordenschat",
      "subSkill": "woord_idioom",
      "questionType": "multiple_choice",
      "question": "Welke zin in deze tekst betekent hetzelfde als 'iemand een hart onder de riem steken'?",
      "options": [
        "\"Je hebt goed geoefend. Je kunt dit!\"",
        "\"Maak je geen zorgen.\"",
        "\"Dank je, dat helpt echt.\"",
        "Bram steekt zijn duim op."
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "readingPassage",
          "showWhen": "always",
          "data": {
            "passage": "Bram ziet dat Lisa zenuwachtig is voor haar spreekbeurt. \"Maak je geen zorgen,\" zegt hij. \"Je hebt goed geoefend. Je kunt dit!\" Lisa glimlacht. \"Dank je, dat helpt echt.\" Bram steekt zijn duim op.",
            "instruction": "Lees de tekst",
            "source": "Voorbeeldtekst"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Check-strategie: idioom in context",
            "content": "'Een hart onder de riem steken' = iemand moed inspreken met woorden. Zoek de zin waarin Bram actief moed geeft door iets POSITIEFS te zeggen over wat Lisa kan.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "idioom_hart_riem_context",
      "variantIndex": 1,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Een hart onder de riem steken' betekent: iemand actief moed inspreken. 'Je hebt goed geoefend. Je kunt dit!' is precies dat — Bram benoemt waarom Lisa het wél kan. De andere opties zijn ofwel te algemeen, of een reactie, of een gebaar (geen gesproken aanmoediging).",
        "solutionSteps": [
          "Wat betekent het idioom? Iemand moed inspreken.",
          "Welke zin spreekt Lisa moed in? 'Je hebt goed geoefend. Je kunt dit!'",
          "'Maak je geen zorgen' is geruststellen, niet specifiek moed inspreken.",
          "'Dank je' is Lisa's reactie, geen aanmoediging van Bram.",
          "De duim opsteken is een gebaar — het idioom gaat over wat je zegt."
        ],
        "distractorExplanations": {
          "0": "Goed! Bram benoemt expliciet waarom Lisa het kan — dat is een hart onder de riem.",
          "1": "Dat is geruststelling, niet hetzelfde als moed inspreken. Een hart onder de riem = benoemen waarom iemand het wél kan.",
          "2": "Dit is Lisa's reactie, geen aanmoediging van Bram.",
          "3": "Dit is een gebaar. Het idioom gaat over wat iemand zegt om moed te geven."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.idioom-geruststelling-vs-aanmoediging", "label": "Geruststelling verward met moed inspreken", "optionIndex": 1 },
          { "id": "taa.idioom-reactie-vs-aanmoediging", "label": "Reactie verward met aanmoediging", "optionIndex": 2 },
          { "id": "taa.idioom-gebaar-vs-gesproken", "label": "Gebaar verward met gesproken aanmoediging", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-WOORD-IDIOOM-002",
      "familyId": "TAA-WOORD-IDIOOM",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "woordenschat",
      "subSkill": "woord_idioom",
      "questionType": "multiple_choice",
      "question": "Waarom heeft Lisa 'vlinders in haar buik'?",
      "options": [
        "Omdat ze zenuwachtig is voor haar optreden.",
        "Omdat ze honger heeft.",
        "Omdat ze blij is met haar vriendin.",
        "Omdat ze ziek is."
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "readingPassage",
          "showWhen": "always",
          "data": {
            "passage": "Lisa staat achter het gordijn te wachten. Zo meteen moet ze optreden voor de hele school. Haar handen trillen een beetje. Haar hart klopt snel. Ze voelt iets kriebelen in haar buik. \"Ik ben zo zenuwachtig!\" fluistert ze tegen haar vriendin.",
            "instruction": "Lees de tekst",
            "source": "Voorbeeldtekst"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Check-strategie: oorzaak in de tekst",
            "content": "Lees de hele tekst. Wat staat er VOOR het kriebelen in de buik? Trillende handen, snel hart kloppen, en Lisa zegt zelf: 'Ik ben zo zenuwachtig'. Dat geeft de oorzaak.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "idioom_vlinders_context",
      "variantIndex": 2,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Vlinders in je buik' is figuurlijk voor een zenuwachtig of opgewonden gevoel. In de tekst zie je dat Lisa moet optreden, haar handen trillen, en ze zegt zelf: 'Ik ben zo zenuwachtig'. De oorzaak is dus duidelijk: zenuwen voor het optreden.",
        "solutionSteps": [
          "Wat betekent het idioom? Een zenuwachtig of opgewonden gevoel.",
          "Welke aanwijzingen geeft de tekst? Optreden, trillende handen, snel hart, 'ik ben zenuwachtig'.",
          "De oorzaak in de tekst = zenuwen voor het optreden."
        ],
        "distractorExplanations": {
          "0": "Goed! De tekst zegt expliciet: 'Ik ben zo zenuwachtig'. Vlinders in je buik = zenuwen.",
          "1": "Er staat niets over honger in de tekst. Vlinders in je buik is een figuurlijk gevoel, geen honger.",
          "2": "Lisa is op dit moment niet blij — ze is zenuwachtig voor haar optreden. Lees haar laatste zin nog eens.",
          "3": "Lisa is niet ziek. De symptomen (trillen, snel hart kloppen) komen door de zenuwen, niet door ziekte."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.idioom-letterlijk-honger", "label": "Verwart figuurlijk gevoel met honger", "optionIndex": 1 },
          { "id": "taa.idioom-context-emotie-omgewisseld", "label": "Mist context-aanwijzingen, kiest 'blij'", "optionIndex": 2 },
          { "id": "taa.idioom-zenuwen-vs-ziekte", "label": "Verwart zenuwen met ziekte", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-WOORD-IDIOOM-003",
      "familyId": "TAA-WOORD-IDIOOM",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "woordenschat",
      "subSkill": "woord_idioom",
      "questionType": "matching",
      "question": "Koppel de uitdrukking aan de juiste betekenis.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {"left": "De knoop doorhakken", "right": "Een beslissing nemen"},
          {"left": "Iets onder de knie hebben", "right": "Iets goed kunnen"},
          {"left": "Met de gebakken peren zitten", "right": "De problemen moeten oplossen"},
          {"left": "Een oogje in het zeil houden", "right": "Iets in de gaten houden"}
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Check-strategie: uitdrukkingen ontleden",
            "content": "Uitdrukkingen hebben een figuurlijke betekenis. Stap 1: stel je de letterlijke handeling voor (een knoop doorhakken = iets vasts losmaken). Stap 2: vertaal dat naar een gevoel of besluit (einde maken aan twijfel = beslissing nemen). Check: past de betekenis in een echte zin? 'Hij hakte de knoop door en koos voor de blauwe' — ja, dat past bij 'beslissing nemen'.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "idioom_matching_1",
      "variantIndex": 3,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.idioom-letterlijk-bijltje", "label": "Letterlijke betekenis verward met figuurlijke" }
        ]
      },
      "feedback": {
        "explanationText": "Uitdrukkingen zijn vaste woordcombinaties met een figuurlijke betekenis. De truc: koppel het beeld aan een gevoel of handeling. 'De knoop doorhakken' = einde maken aan twijfel → een beslissing nemen. 'Iets onder de knie hebben' = vasthouden zoals een hond die je tussen je knieën klemt → iets beheersen / goed kunnen. 'Met de gebakken peren zitten' = de onaangename rest opruimen → de problemen moeten oplossen. 'Een oogje in het zeil houden' = vroeger op zee de wind bewaken via de zeilen → iets in de gaten houden. Check je antwoord altijd door de betekenis in een voorbeeldzin terug te lezen.",
        "solutionSteps": [
          "Beeld bij elk idioom voorstellen (letterlijke handeling)",
          "Koppel het beeld aan een gevoel of doel",
          "De knoop doorhakken → Beslissing nemen",
          "Onder de knie hebben → Goed kunnen",
          "Gebakken peren → Problemen oplossen",
          "Oogje in het zeil → In de gaten houden",
          "Check: past de betekenis in een echte zin?"
        ]
      }
    },
    {
      "id": "TAA-WOORD-IDIOOM-004",
      "familyId": "TAA-WOORD-IDIOOM",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "woordenschat",
      "subSkill": "woord_idioom",
      "questionType": "multiple_choice",
      "question": "In welke zin in deze tekst gebeurt hetzelfde als bij 'van een mug een olifant maken'?",
      "options": [
        "\"Nu denkt de juf vast dat ik dom ben!\"",
        "\"Janneke heeft een 8!\"",
        "\"Maak het niet groter dan het is.\"",
        "\"Een 7? Dat is toch goed?\""
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "readingPassage",
          "showWhen": "always",
          "data": {
            "passage": "\"Mam, ik heb een 7 voor mijn toets!\" roept Tom. \"Een 7? Dat is toch goed?\" zegt zijn moeder. \"Ja, maar Janneke heeft een 8! Nu denkt de juf vast dat ik dom ben!\" Zijn moeder lacht. \"Tom, één punt verschil is niet erg. Maak het niet groter dan het is.\"",
            "instruction": "Lees de tekst",
            "source": "Voorbeeldtekst"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Check-strategie: transfer-patroon",
            "content": "'Van een mug een olifant maken' = iets kleins veel groter maken dan het is. Zoek de zin waarin iemand een KLEIN ding (één punt verschil) GROOT maakt (juf denkt dat ik dom ben).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "idioom_mug_olifant_transfer",
      "variantIndex": 4,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'Van een mug een olifant maken' = van iets kleins iets groots maken. Tom maakt van één punt verschil (klein) de conclusie dat de juf hem dom vindt (groot). 'Nu denkt de juf vast dat ik dom ben!' is precies dezelfde overdrijving.",
        "solutionSteps": [
          "Wat doet 'van een mug een olifant maken'? Iets kleins groot maken.",
          "Welk klein ding is er? Eén punt verschil (7 vs 8).",
          "Welke zin maakt daar iets groots van? 'Nu denkt de juf vast dat ik dom ben!'",
          "Dat is dezelfde overdrijving."
        ],
        "distractorExplanations": {
          "0": "Goed! Tom maakt van één punt verschil een grote conclusie — dezelfde overdrijving.",
          "1": "Dat is gewoon een feit (Janneke heeft een 8). Daar wordt niets groter gemaakt dan het is.",
          "2": "Dat is juist het ADVIES tegen overdrijven, niet de overdrijving zelf.",
          "3": "Dat is een relativering door de moeder, geen overdrijving."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.idioom-transfer-feit-verward", "label": "Verwart feit met overdrijving", "optionIndex": 1 },
          { "id": "taa.idioom-transfer-advies-omgewisseld", "label": "Verwart advies-tegen met overdrijving", "optionIndex": 2 },
          { "id": "taa.idioom-transfer-relativering-verward", "label": "Verwart relativering met overdrijving", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-WOORD-IDIOOM-005",
      "familyId": "TAA-WOORD-IDIOOM",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "woordenschat",
      "subSkill": "woord_idioom",
      "questionType": "matching",
      "question": "Koppel de uitdrukking aan de juiste betekenis.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {"left": "De bloemetjes buiten zetten", "right": "Flink feestvieren"},
          {"left": "Iemand een hart onder de riem steken", "right": "Iemand moed inspreken"},
          {"left": "Het neusje van de zalm", "right": "Het allerbeste"},
          {"left": "Water bij de wijn doen", "right": "Een compromis sluiten"}
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Check-strategie: figuurlijk taalgebruik",
            "content": "Stap 1: denk niet aan de letterlijke woorden (bloemen, hart, zalm, wijn) maar aan het bedoelde gevoel of doel. Stap 2: zoek een hedendaagse parafrase. 'Water bij de wijn doen' = je drank zachter maken = je standpunt zachter maken = compromis. Check: past de parafrase in een echte zin? 'Ze deden allebei water bij de wijn en kwamen eruit' — ja, dat is een compromis.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "idioom_matching_2",
      "variantIndex": 5,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.idioom-letterlijk-bijltje", "label": "Letterlijke betekenis verward met figuurlijke" }
        ]
      },
      "feedback": {
        "explanationText": "Bij idiomen vertaal je het beeld naar een gevoel of handeling. 'De bloemetjes buiten zetten' — vroeger zette je bloemen buiten op feestdagen → flink feestvieren. 'Iemand een hart onder de riem steken' — letterlijk je hart geven aan iemand → moed inspreken of troosten. 'Het neusje van de zalm' — het lekkerste stukje vis → het allerbeste deel. 'Water bij de wijn doen' — je wijn slapper maken zodat hij voor iedereen drinkbaar is → toegeven om een afspraak te maken. Check altijd: past de betekenis in een gewone zin?",
        "solutionSteps": [
          "Beeld voorstellen bij elk idioom",
          "Beeld vertalen naar een gevoel of doel",
          "Bloemetjes buiten zetten → Feestvieren",
          "Hart onder de riem → Moed inspreken",
          "Neusje van de zalm → Het allerbeste",
          "Water bij de wijn → Compromis sluiten",
          "Check: kun je de betekenis in een gewone zin gebruiken?"
        ]
      }
    },
    {
      "id": "TAA-WOORD-IDIOOM-006",
      "familyId": "TAA-WOORD-IDIOOM",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "woordenschat",
      "subSkill": "woord_idioom",
      "questionType": "fill_in",
      "question": "Vul het juiste idioom in. Lisa heeft geen zin om te leren voor de toets. Ze _____ . (kies een uitdrukking met dezelfde betekenis als 'het uitstellen')",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "placeholder": "schuift het op de lange baan",
        "inputType": "text",
        "acceptedAnswers": [
          "schuift het op de lange baan",
          "schuift het op de lange baan.",
          "schuift het op de lange baan",
          "schuift het voor zich uit",
          "stelt het op de lange baan"
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Check-strategie: idioom voor uitstellen",
            "content": "Een lange baan = ver weg = je legt de taak ver vooruit = je stelt 'm uit. De uitdrukking is: 'iets op de lange baan schuiven'.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "idioom_lange_baan_fill",
      "variantIndex": 6,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Het idioom voor 'uitstellen' is 'iets op de lange baan schuiven'. De volledige zin wordt: 'Ze schuift het op de lange baan.'",
        "solutionSteps": [
          "Wat betekent uitstellen? Iets ver vooruit leggen.",
          "Welk idioom past? 'Op de lange baan schuiven' — een lange baan is ver weg.",
          "Volledige zin: 'Ze schuift het op de lange baan.'"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.idioom-fill-letterlijk-gekozen", "label": "Letterlijke omschrijving gekozen i.p.v. idioom" }
        ]
      }
    },
    {
      "id": "TAA-WOORD-IDIOOM-007",
      "familyId": "TAA-WOORD-IDIOOM",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "woordenschat",
      "subSkill": "woord_idioom",
      "questionType": "multiple_choice",
      "question": "Lees: 'Tom gooide het bijltje erbij neer toen het te moeilijk werd.'",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "mode": "two_step_judge",
        "step1": {
          "prompt": "Wordt deze uitdrukking letterlijk of figuurlijk bedoeld?",
          "options": ["Letterlijk", "Figuurlijk"],
          "correctIndex": 1
        },
        "step2_ifIndex": 1,
        "step2": {
          "prompt": "Wat betekent 'het bijltje erbij neergooien'?",
          "options": ["Opgeven, ergens mee stoppen", "Een echt bijltje weggooien", "Heel boos worden", "Hard werken"],
          "correctIndex": 0
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Letterlijk of figuurlijk?",
            "content": "Tom heeft geen echt bijltje. 'Het bijltje erbij neergooien' is een uitdrukking voor: opgeven, ergens mee stoppen omdat het te zwaar wordt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "idioom_bijltje_neergooien",
      "variantIndex": 7,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.idioom-letterlijk-bijltje", "label": "Neemt 'bijltje' letterlijk" }
        ]
      },
      "feedback": {
        "explanationText": "'Het bijltje erbij neergooien' is figuurlijk en betekent: opgeven of stoppen. Stap 1: figuurlijk (Tom gooit geen echt bijltje weg). Stap 2: opgeven.",
        "solutionSteps": [
          "Stap 1: Tom heeft geen echte bijl → figuurlijk",
          "Stap 2: 'Bijltje erbij neergooien' = stoppen, opgeven",
          "Hier: Tom geeft op omdat het te moeilijk werd"
        ]
      }
    }
  ]
}